import type { SessionProviderProps } from 'next-auth/react';

/**
 * next-auth refetches `/api/auth/session` on every focus, and each refetch is
 * broadcast to the site's other tabs, which refetch too: 1–4 calls per tab
 * switch. With MULTI_CART on (CPS-7696) the session is not refetched on
 * focus or on a timer (next-auth's poll broadcasts too). The bridge-token
 * code proves the session with the server itself before any user mint
 * (CPS-7883), and a sign-out in another tab still reaches this one through
 * next-auth's broadcast. A session cookie cleared by a failed token refresh in
 * middleware is caught by WithAuthSync's throttled `refetchSessionQuietly`.
 */
export const sessionRefetchProps = (
  isMultiCartEnabled: boolean
): Pick<SessionProviderProps, 'refetchOnWindowFocus' | 'refetchInterval'> =>
  isMultiCartEnabled ? { refetchOnWindowFocus: false, refetchInterval: 0 } : {};

/**
 * Makes SessionProvider refetch the session without telling the other tabs.
 * next-auth 4 answers a `nextauth.message` storage event with
 * `getSession({ broadcast: false })` and stores the result, and an event
 * dispatched here never reaches another tab.
 */
export const refetchSessionQuietly = (): void => {
  window.dispatchEvent(
    new StorageEvent('storage', {
      key: 'nextauth.message',
      newValue: JSON.stringify({
        event: 'session',
        data: { trigger: 'getSession' },
      }),
    })
  );
};
